import { RevampedThemeColors, ThemeColor } from '@lib/constants/Colors';

export type ThemeColorString = ThemeColor | `${ThemeColor}/${string}`;

const color = (colorString: ThemeColorString) => {
    // Had to cast here because of the split function
    const [colorKey, opacity]: [ThemeColor, string | undefined] = colorString.split('/') as [
        ThemeColor,
        string | undefined
    ];

    const colorValue = RevampedThemeColors[colorKey];

    if (!colorValue) {
        throw new Error(`color ${colorKey} not found`);
    }

    if (opacity) {
        const opacityValue = parseInt(opacity, 10);
        if (opacityValue < 0 || opacityValue > 100) {
            throw new Error('Opacity must be between 0 and 100');
        }
        const alpha = Math.round((opacityValue / 100) * 255);
        const hex = alpha.toString(16).padStart(2, '0').toUpperCase();
        return `${colorValue}${hex}`;
    }

    return colorValue;
};

export default color;
